export const SET_KEY = 'setKey';
export const SET_ACTS_ID = 'setActsId';

export const DISPLAY_UPDATE = 'displayUpdate';
export const BOOKING_UPDATE = 'bookingUpdate';
export const BOOKING_RESET = 'bookingReset';
